'use client'

import { motion } from 'framer-motion'
import { Bell, CheckCircle, Zap } from 'lucide-react'
import * as React from 'react'
import { cn } from '#app/utils/misc.tsx'
export interface FeatureListProps {
	className?: string
	features?: {
		icon: React.ElementType
		text: string
	}[]
}
const defaultFeatures = [
	{
		icon: Bell,
		text: 'Get notified of new grants that match your profile.',
	},
	// {
	// 	icon: Star,
	// 	text: 'Save time with personalized recommendations.',
	// },
	{
		icon: CheckCircle,
		text: 'Track and manage your funding interests effortlessly.',
	},
	{
		icon: Zap,
		text: 'Stay ahead with real-time updates on opportunities.',
	},
]
export default function FeatureList({
	className,
	features = defaultFeatures,
}: FeatureListProps) {
	return (
		<motion.aside
			aria-label="Funding Profile Benefits"
			className={cn(
				'flex flex-col items-center px-4 py-8 sm:px-6 md:items-end md:py-16 lg:px-8',
				className,
			)}
			initial={{
				opacity: 0,
				y: 20,
			}}
			animate={{
				opacity: 1,
				y: 0,
			}}
			transition={{
				duration: 0.5,
				delay: 0.2,
			}}
		>
			<div className="w-full max-w-[40ch] text-left">
				<motion.h2
					className="text-foreground mb-8 text-3xl font-semibold"
					initial={{
						opacity: 0,
						y: 10,
					}}
					animate={{
						opacity: 1,
						y: 0,
					}}
					transition={{
						duration: 0.5,
						delay: 0.3,
					}}
				>
					Why Create a Funding Profile?
				</motion.h2>
				<ul className="space-y-6">
					{features.map((feature, index) => {
						const IconComponent = feature.icon
						return (
							<motion.li
								key={index}
								className="flex flex-col items-center gap-3 text-left md:flex-row md:items-start"
								initial={{
									opacity: 0,
									x: -20,
								}}
								animate={{
									opacity: 1,
									x: 0,
								}}
								transition={{
									duration: 0.4,
									delay: 0.4 + index * 0.1,
								}}
							>
								<div className="bg-primary/10 text-primary flex-shrink-0 rounded-full p-2.5 md:order-2">
									<IconComponent className="h-5 w-5" />
								</div>
								<p className="text-muted-foreground text-base leading-relaxed md:order-1">
									{feature.text}
								</p>
							</motion.li>
						)
					})}
				</ul>
			</div>
		</motion.aside>
	)
}
